import { SparkIteration } from '../types/sparkTypes';

/**
 * Parse an ISO timestamp string to milliseconds since epoch.
 * Returns 0 if null or invalid.
 */
export function parseTimestamp(ts: string | null): number {
  return ts ? new Date(ts).getTime() : 0;
}

/**
 * Returns true if the iteration has never been seen, or if its changed_at
 * timestamp is strictly greater than last_time_seen.
 */
export function isIterationUnseen(iter: SparkIteration): boolean {
  const lastSeen = parseTimestamp(iter._last_time_seen);
  const changedAt = parseTimestamp(iter._changed_at);
  if (!iter._last_time_seen) {
    return true;
  }
  return changedAt > lastSeen;
}

/**
 * From a list of iterations, returns the one with the highest iteration_number
 * that is considered unseen. Returns undefined if none are unseen.
 */
export function getNewestUnseenIteration(iterations: SparkIteration[]): SparkIteration | undefined {
  const unseen = iterations.filter(isIterationUnseen);
  if (unseen.length === 0) {
    return undefined;
  }
  return unseen.reduce((prev, curr) =>
    curr._iteration_number > prev._iteration_number ? curr : prev
  );
} 